import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: min(40rem, 90vw);
    position: relative;
    background: ${theme.color.white};
    padding: 6.1rem 3.7rem 3.4rem;
    border-radius: 0.4rem;
  `}
`;

export const Links = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 3.4rem;

    button {
      color: #b3b3b3;
      font-size: 2.1rem;
      font-weight: ${theme.font.weight.medium};

      &.active {
        color: ${theme.color.primary};
      }
    }

    button + button {
      margin-left: 3rem;
    }
  `}
`;

export const CloseButton = styled.div`
  display: inline-block;
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 4px 8px;
  cursor: pointer;
`;

export const Content = styled.div`
  ${({ theme }) => css`
    form {
      text-align: center;

      input:not([type='checkbox']) {
        margin-bottom: 1.3rem;

        &::placeholder {
          color: ${theme.color.primary};
        }
      }
    }
  `}
`;
